var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"use texture-bg-css"},[_c('Top'),_c('Storage'),_c('Anything'),_c('Service')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }